import Vue from 'vue'
import messageConfig from './messageBoxCancle.vue'

function messageBoxCancle(msg,call,callC) {
    let messageBoxTpl = Vue.extend(messageConfig);
    let messageBoxPro = new messageBoxTpl({
        el:document.createElement('div')
    });
    document.body.appendChild(messageBoxPro.$el);
    messageBoxPro.$watch('messageBoxShow',function (val) {
        if(!val){
            messageBoxPro.$destroy(true);
            messageBoxPro.$el.parentNode.removeChild(messageBoxPro.$el)
        }
    });
    messageBoxPro.message = msg;
    messageBoxPro.messageBoxShow = true;
    messageBoxPro.callBack = call;
    messageBoxPro.callBackC = callC;
}
export default messageBoxCancle



// WEBPACK FOOTER //
// ./src/components/messageBoxCancle/messageBoxCancle.js